// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2Sj1B","addWidgetButton":"Header_addWidgetButton__N_Szu","dashboardTabs":"Header_dashboardTabs__3JjHD","active":"Header_active__1mj8g"};